export const PAGE_SIZE = 6;

export const HEADER_IDS = {
  DATE: 'date',
  INTERVENER: 'intervener',
  DETAIL: 'details'
};
